import { FC } from 'react';

import { SubmitButton } from 'src/general/components/Button/SubmitButton';
import { FormGenericError } from 'src/general/components/forms/FormGenericError/FormGenericError';
import { FormWithAction } from 'src/general/components/forms/FormWithAction/FormWithAction';
import { InputEmailForm } from 'src/general/components/forms/Input/InputEmailForm';

import { newsletterSignupAction } from './NewsletterSignup.action';

interface Props {
  onSuccess: (email: string) => void;
}

export const NewsletterSignupForm: FC<Props> = ({ onSuccess }) => {
  return (
    <FormWithAction
      action={newsletterSignupAction}
      withRecaptcha="newsletter"
      onSuccess={(success) => onSuccess(success.message)}
      renderContent={(state) => (
        <>
          <div className="flex flex-col smp:flex-row smp:gap-4">
            <div className="w-full smp:w-4/5">
              <InputEmailForm
                name="email"
                label="Email address"
                showClientError
                formState={state}
                data-testid="email"
              />
            </div>
            <div className="h-15 w-full smp:w-1/5">
              <SubmitButton fullWidth>Sign up</SubmitButton>
            </div>
          </div>
          <FormGenericError formState={state} />
        </>
      )}
    />
  );
};
